module.exports = __webpack_public_path__ + "h5/img/wan.5fe4ce92.png";